import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=fbae21b0&scoped=true&"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js&"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxComponent.vue?vue&type=style&index=0&id=fbae21b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbae21b0",
  null
  
)

export default component.exports